import React from "react";
import styled from "styled-components";
import { textGradient } from "../GradientBox";
import { SizedBox } from "../SizedBox";
import BiologicalAgeCheckIllustration from "./BiologicalAgeCheckIllustration";
import { LandingPageTemplate } from "./LandingTemplate";

export const BiologicalAgeCheckLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      header={<Header />}
      illustration={<BiologicalAgeCheckIllustration />}
      androidStoreListing={"bio"}
      appStorePpid={"cd8574e3-24a0-4b69-ae3a-ee487888abd2"}
    />
  );
};

export default BiologicalAgeCheckLanding;

const Header: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ContentHeader>
        Ile naprawdę
        <br />
        masz lat?
      </ContentHeader>
      <SizedBox height={4} />
      <ContentBody>Wynik w kilka minut</ContentBody>
    </div>
  );
};

const ContentHeader = styled.h1`
  font-size: 32px;
  font-weight: bold;
  background: ${textGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0px;
`;

const ContentBody = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 0px;
`;
